<template>
    <TsCard noShadow append-class="bg-white" v-if="!accountStore.is_credit_limit_form_filled">
        <TsRow class="flex items-center mb-4 pl-2">
            <TsIcon name="akar-icons:arrow-left" :size="24" class="mr-4 cursor-pointer" @click="navigateTo('/account/pro-card')">
            </TsIcon>
            <TsTypography appendClass="font-semibold leading-2 text-xl text-secondary-black" :text= "useTranslation('ProCard-requestToIncreaseCreditLimit', 'Verzoek om verhoging van de kredietlimiet')" />
        </TsRow>
        <TsDivider append-class="min-h-0" />

        <TsRow append-class="flex-col">
            <TsTypography appendClass="font-semibold leading-2 text-lg px-3 text-secondary-black" :text= "useTranslation('ProCard-companyInformation', 'Bedrijfs Informatie')" />
            <TsRow append-class="justify-between max-w-lg pl-5">
                <TsTypography appendClass="leading-2 text-base"  :text= "useTranslation('ProCard-customerId' , 'Klant-Id') + '*'" />
                <TsTypography appendClass="leading-2 text-base" :text="customerId" />
            </TsRow>
        </TsRow>
        <TsDivider append-class="min-h-0 my-2" />
        <TsCreditLimitForm />
      </TsCard>

      <TsCard noShadow append-class="bg-white"  >
        <TsRow v-if="accountStore.is_credit_limit_form_filled">
            <TsColumn append-class="p-2">
                <TsRow appendClass="justify-center">
                    <TsImage src="/images/thankyou.webp" width="110" height="110" class="mx-auto" loading="lazy"/>
                </TsRow>
                <TsRow append-class="justify-center">
                    <TsTypography align="center" append-class="text-primary" as="h1">{{useTranslation("thankyou","Bedankt")}} !</TsTypography>
                </TsRow>
                <TsRow append-class="justify-center">
                    <TsTypography align="center" append-class="text-primary text-lg">
                        {{useTranslation("ProCard-applicationSuccessMessage" ,"Uw aanvraag is ingediend. We nemen binnenkort weer contact met u op")}}
                    </TsTypography>
                </TsRow>
                <TsRow  class="gap-2 justify-center py-5">
            <TsButton append-class="px-12 whitespace-nowrap" label="Go Home" @click="navigateToHome()" />
        </TsRow>
            </TsColumn>
        </TsRow>
      </TsCard>
      
        
</template>

<script setup>
const TsCard = defineAsyncComponent(() => import('~/components/organisms/TsCard.vue'));
const TsCreditLimitForm = defineAsyncComponent(() => import('~/components/organisms/TsCreditLimitForm.vue'));

const authStore = useAuthStore();
const accountStore = useAccountStore()
const customerId = computed(() => authStore.user && authStore.user.id);

const navigateToHome = () => {
    navigateTo("/");
    setTimeout(() => {
        accountStore.is_credit_limit_form_filled = false;
    },3000)
}

onUnmounted(() => {
    setTimeout(() => {
        accountStore.is_credit_limit_form_filled = false;
        accountStore.credit_limit_form.requested_limit = "";
        accountStore.credit_limit_form.authorized_signatory = "";
        accountStore.credit_limit_form.company_name = "";
        accountStore.credit_limit_form.company_registration_no = "";
        accountStore.credit_limit_form.current_limit = "";
        accountStore.credit_limit_form.requested_limit = "";
        accountStore.is_credit_checkbox = false;
    },1200)
})

definePageMeta({
    layout: 'account'
})

</script>
